export enum EnpsAdditionalQuestions {
    NONE = 'NONE',
    SHOW_ALL = 'SHOW_ALL',
    SHOW_ON_RESULT = 'SHOW_ON_RESULT'
  }
  
  